export default __webpack_public_path__ + "static/media/react.e07efd84.svg";